import * as ProposalNS from '../Proposal';
import * as ProposalElementNS from '../ProposalElements';

import { formatLocalizedString, LOCALE } from '@/utils/i18n';
import Locale from '@/types/locale';

const getTitleDelimiterForLocale = (locale: Locale) => (locale === LOCALE.FR_CA ? ' : ' : ': ');

export const getSectionDisplayTitle = (section: ProposalElementNS.ProposalSectionElement, proposal: ProposalNS.Proposal): string => {
  const baseTitle = formatLocalizedString(section.label, proposal.options.locale);

  if (section.sectionKey === 'EXECUTIVE_SUMMARY' && section.sectionIteratorIndex != null) {
    const accountSetName = proposal.accountSets?.[section.sectionIteratorIndex]?.name?.trim();

    if (accountSetName) {
      const delimiter = getTitleDelimiterForLocale(proposal.options.locale);
      return `${baseTitle}${delimiter}${accountSetName}`;
    }
  }

  return baseTitle;
};
